// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for the navigation row */

/* Styles for each nav item */

/* Style for nav cards */
/* .anav-card {
  border: none;
  background-color: transparent;
  text-align: center;
  padding: 10px;
} */

/* Active page indication */
.active-page .nav-icon,
.active-page .nav-label {
  color: #3ca8e8; /* Highlight color for active page */
  text-align: center;
}
.Inactive {
  text-align: center;
}
.accordion-item {
  border-radius: 0 !important;
}

.accordion-button {
  border-radius: 0 !important;
}
.form-select {
  border-radius: 0 !important;
}
.accordion-button:not(.collapsed) {
  background-color: #fff;
}
/* Media query for mobile responsiveness */

.pen {
  color: #007bff;
  background-color: #f0f0f0; /* Change to desired active background color */
  border: 2px solid #3ca8e8; /* Change to desired active border color */
  border-radius: 4px; /* Optional: add some border radius */
  padding: 5px; /* Optional: add some padding */
}
#quotesrow {
  border: 1px solid #25335b;
  box-shadow: 0 5px 15px rgba(60, 168, 232, 0.2),
    0 10px 20px rgba(136, 136, 136, 0.15); /* Soft gradient shadow effect */
}
.navigation-row {
  border: 1px solid rgb(60, 168, 232);
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(60, 168, 232, 0.2),
    0 10px 20px rgba(136, 136, 136, 0.15); /* Soft gradient shadow effect */
}
.sticky-row {
  position: sticky;
  top: 0; /* Adjust this value based on your header height */
  z-index: 1000; /* Ensure it stays above other content */
  background-color: white; /* Optional: add a background color to match your page */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: add a shadow for visual separation */
}
/* Existing styles remain unchanged */
.quote-card {
  border-radius: 8px;
  background-color: #f8f9fa;
}

.pay-btn {
  width: 100%;
  max-width: 150px;
}
.gradient_anim_btn {
  color: white;
  font-weight: 600;
  font-size: 14px;
  margin: 12px;
  padding: 14px 20px 14px 20px;
  border-radius: 0.7em;

  background: -webkit-linear-gradient(
      225deg,
      rgb(68 152 111),
      rgb(66 92 150),
      rgb(60 168 232)
    )
    0% 0% / 300% 300%;
  background-size: 200% auto;
  animation: gradient_move 3s ease infinite;
}
.alert {
  display: block !important;
  visibility: visible !important;
}
.previousPolicy .react-datepicker-wrapper {
  display: block;
}
.react-datepicker-wrapper input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.chekboxlabel label {
  font-style: italic;
  font-weight: 100 !important;
}
.SATPMotorQuotesPage .nav-label {
  font-size: 18px;
  margin-bottom: 0px;
}
span.react-datepicker__year-read-view--down-arrow,
span.react-datepicker__month-read-view--down-arrow {
  display: none;
}
.css-13cymwt-control {
  border-radius: 0px;
}
.SATPMotorQuotesPageMain .form-check {
  line-height: 14px;
}
.form-range {
  accent-color: #0d6efd; /* Bootstrap primary color */
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/MotorScreen/motorpolicies.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC,6BAA6B;;AAE7B,wBAAwB;AACxB;;;;;GAKG;;AAEH,2BAA2B;AAC3B;;EAEE,cAAc,EAAE,oCAAoC;EACpD,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA,0CAA0C;;AAE1C;EACE,cAAc;EACd,yBAAyB,EAAE,8CAA8C;EACzE,yBAAyB,EAAE,0CAA0C;EACrE,kBAAkB,EAAE,qCAAqC;EACzD,YAAY,EAAE,+BAA+B;AAC/C;AACA;EACE,yBAAyB;EACzB;yCACuC,EAAE,gCAAgC;AAC3E;AACA;EACE,mCAAmC;EACnC,mBAAmB;EACnB;yCACuC,EAAE,gCAAgC;AAC3E;AACA;EACE,gBAAgB;EAChB,MAAM,EAAE,kDAAkD;EAC1D,aAAa,EAAE,wCAAwC;EACvD,uBAAuB,EAAE,wDAAwD;EACjF,wCAAwC,EAAE,iDAAiD;AAC7F;AACA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;;EAEpB;;;;;;qBAMmB;EACnB,0BAA0B;EAE1B,yCAAyC;AAC3C;AACA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,mCAAmC;EACnC,4BAA4B;EAC5B,2DAA2D;EAC3D,kBAAkB;EAClB,wEAAwE;AAC1E;AACA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB,EAAE,4BAA4B;AACrD","sourcesContent":["/* Styles for the navigation row */\r\n\r\n/* Styles for each nav item */\r\n\r\n/* Style for nav cards */\r\n/* .anav-card {\r\n  border: none;\r\n  background-color: transparent;\r\n  text-align: center;\r\n  padding: 10px;\r\n} */\r\n\r\n/* Active page indication */\r\n.active-page .nav-icon,\r\n.active-page .nav-label {\r\n  color: #3ca8e8; /* Highlight color for active page */\r\n  text-align: center;\r\n}\r\n.Inactive {\r\n  text-align: center;\r\n}\r\n.accordion-item {\r\n  border-radius: 0 !important;\r\n}\r\n\r\n.accordion-button {\r\n  border-radius: 0 !important;\r\n}\r\n.form-select {\r\n  border-radius: 0 !important;\r\n}\r\n.accordion-button:not(.collapsed) {\r\n  background-color: #fff;\r\n}\r\n/* Media query for mobile responsiveness */\r\n\r\n.pen {\r\n  color: #007bff;\r\n  background-color: #f0f0f0; /* Change to desired active background color */\r\n  border: 2px solid #3ca8e8; /* Change to desired active border color */\r\n  border-radius: 4px; /* Optional: add some border radius */\r\n  padding: 5px; /* Optional: add some padding */\r\n}\r\n#quotesrow {\r\n  border: 1px solid #25335b;\r\n  box-shadow: 0 5px 15px rgba(60, 168, 232, 0.2),\r\n    0 10px 20px rgba(136, 136, 136, 0.15); /* Soft gradient shadow effect */\r\n}\r\n.navigation-row {\r\n  border: 1px solid rgb(60, 168, 232);\r\n  border-radius: 10px;\r\n  box-shadow: 0 5px 15px rgba(60, 168, 232, 0.2),\r\n    0 10px 20px rgba(136, 136, 136, 0.15); /* Soft gradient shadow effect */\r\n}\r\n.sticky-row {\r\n  position: sticky;\r\n  top: 0; /* Adjust this value based on your header height */\r\n  z-index: 1000; /* Ensure it stays above other content */\r\n  background-color: white; /* Optional: add a background color to match your page */\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: add a shadow for visual separation */\r\n}\r\n/* Existing styles remain unchanged */\r\n.quote-card {\r\n  border-radius: 8px;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.pay-btn {\r\n  width: 100%;\r\n  max-width: 150px;\r\n}\r\n.gradient_anim_btn {\r\n  color: white;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  margin: 12px;\r\n  padding: 14px 20px 14px 20px;\r\n  border-radius: 0.7em;\r\n\r\n  background: -webkit-linear-gradient(\r\n      225deg,\r\n      rgb(68 152 111),\r\n      rgb(66 92 150),\r\n      rgb(60 168 232)\r\n    )\r\n    0% 0% / 300% 300%;\r\n  background-size: 200% auto;\r\n  -webkit-animation: gradient_move 3s ease infinite;\r\n  animation: gradient_move 3s ease infinite;\r\n}\r\n.alert {\r\n  display: block !important;\r\n  visibility: visible !important;\r\n}\r\n.previousPolicy .react-datepicker-wrapper {\r\n  display: block;\r\n}\r\n.react-datepicker-wrapper input {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: var(--bs-body-color);\r\n  appearance: none;\r\n  background-color: var(--bs-body-bg);\r\n  background-clip: padding-box;\r\n  border: var(--bs-border-width) solid var(--bs-border-color);\r\n  border-radius: 0px;\r\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n.chekboxlabel label {\r\n  font-style: italic;\r\n  font-weight: 100 !important;\r\n}\r\n.SATPMotorQuotesPage .nav-label {\r\n  font-size: 18px;\r\n  margin-bottom: 0px;\r\n}\r\nspan.react-datepicker__year-read-view--down-arrow,\r\nspan.react-datepicker__month-read-view--down-arrow {\r\n  display: none;\r\n}\r\n.css-13cymwt-control {\r\n  border-radius: 0px;\r\n}\r\n.SATPMotorQuotesPageMain .form-check {\r\n  line-height: 14px;\r\n}\r\n.form-range {\r\n  accent-color: #0d6efd; /* Bootstrap primary color */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
